import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useEnableLlmClient = () => {
  const {
    data: isEnabled,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<boolean>((_) => true);

  const enableLlmClient = async (llmName: string, id: string) => {
    await call(`/admin/llm/${llmName}/clients/${id}/enable`, "PUT");
  };

  return {
    enableLlmClient,
    isEnabled,
    isLoading,
    isFailed,
  };
};
